import { isPlatformBrowser } from '@angular/common';
import { Component, inject, OnInit, PLATFORM_ID } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ConfigService } from './shared/config/config.service';
import { ScriptLoaderService } from './shared/services/script-loader.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  private readonly configService = inject(ConfigService);
  private readonly scriptLoader = inject(ScriptLoaderService);
  private readonly platformId = inject(PLATFORM_ID);

  ngOnInit(): void {
    this.clearStorageOnRefresh();
    this.initializeApp();
  }

  private clearStorageOnRefresh(): void {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }

    const navigationEntries = performance.getEntriesByType(
      'navigation',
    ) as PerformanceNavigationTiming[];
    const isPageReload = navigationEntries.length > 0 && navigationEntries[0].type === 'reload';

    if (isPageReload) {
      localStorage.clear();
      sessionStorage.clear();
      console.log('Storage cleared due to page refresh');
    }
  }

  private async initializeApp(): Promise<void> {
    if (this.configService.ENABLE_RECAPTCHA) {
      try {
        await this.scriptLoader.loadScript(
          `https://www.google.com/recaptcha/enterprise.js?render=${this.configService.RECAPTCHA_KEY}`,
        );
      } catch (error) {
        console.error('Failed to load reCAPTCHA:', error);
      }
    }
  }
}
